import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import {createCellRenderer} from "../../helpers/grids/helpers";
import {getLinkifiedPublicId, getLinkifiedText} from "../../helpers/linkifyContent";

function initThirdPartyCompaniesDetail() {

	// Init grid
	const orderThirdPartyCompaniesGrid = document.querySelector('.orders-third-party-companies-grid');
	if (orderThirdPartyCompaniesGrid) {
		createGrid(orderThirdPartyCompaniesGrid, {
				columnDefs: [
					{
						field: "public_id",
						headerName: 'Order Id',
						tooltipField: 'public_id',
						maxWidth: 120,
						cellRenderer: createCellRenderer(params => {
							const detailUrl = params.data.detailUrl
							const public_id = params.data.public_id
							return getLinkifiedPublicId({detailUrl, public_id})
						}),
					},
					{
						field: "voe_company_name",
						headerName: 'Company',
						sortable: false,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedVariable
							const detailUrl = params.data.voeCompanyDetailUrl
							// noinspection JSUnresolvedVariable
							const name = params.data.voe_company_name
							if (detailUrl && name) {
								return getLinkifiedText(detailUrl, name)
							}
							return '<span class="text-muted">Unassigned</span>';
						})
					},
					{
						field: "status_label",
						headerName: 'Status',
						sortable: false,

					},
					{
						field: "assigned_to_full_name",
						headerName: 'Assigned To',
						sortable: false,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedVariable
							return params.data.assigned_to_full_name ?
								params.data.assigned_to_full_name :
								createElement('<span class="text-muted">On Queue</span>');
						})
					},
				],

				rowClass: 'cursor-pointer',
				paginationPageSize: 20,
				_rowName: 'Linked Orders',
			},
			window['routes/admin.voe-orders.linked-third-party-companies-orders.grid']
		);
	}
}

export {initThirdPartyCompaniesDetail}
